import { fetchFromRTM } from "./index";
import * as constants from "./constants";
class KnowledgeMapResolver {
  constructor(connection) {
    this.connection = connection;
  }
  /**
   * Allows the user to get list of contributer for a KnowledgeMap. See
   *   [RTM Docs](unsightly-rock.cloudvent.net/messages/workspace-collaborator-summary/)
   * @param {string} payload.documentId
   * @returns {Promise.<projectId: string, permissionLevel: string>}
   */
  workspaceCompetencyCollaboratorSummary = async (documentId) => {
    const message = {
      type: constants.RTM_WORKSPACE_COMPETENCY_COLLABORATOR_SUMMARY,
      documentId,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_WORKSPACE_COMPETENCY_COLLABORATOR_SUMMARY_OK,
      constants.RTM_WORKSPACE_PROJECT_COLLABORATOR_SUMMARY_ERROR
    );

    return response;
  };
  /**
   * Allows the user to grant permission to a KnowledgeMap. See
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/workspace-competency-permission-grant/)
   * @param {Object} payload
   * @param {array} payload.accountOrTeamIds
   * @param {string} payload.documentId
   * @param {string} payload.permissionLevel
   * @returns {Promise.<projectId: string, permissionLevel: string>}
   */
  workspaceCompetencyPermisssionGrant = async ({
    accountOrTeamIds,
    documentId,
    collaboratorType,
    permissionLevel,
  }) => {
    const message = {
      type: constants.RTM_WORKSPACE_COMPETENCY_PERMISSION_GRANT,
      [`${collaboratorType}Ids`]: [accountOrTeamIds],
      documentId,
      permissionLevel,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_WORKSPACE_COMPETENCY_PERMISSION_GRANT_OK,
      constants.RTM_WORKSPACE_COMPETENCY_PERMISSION_GRANT_ERROR
    );
    return response;
  };
  /**
   * Allows the user to revoke permission to a KnowledgeMap. See
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/workspace-competency-permission-revoke/)
   * @param {Object} payload
   * @param {array} payload.accountOrTeamIds
   * @param {string} payload.documentId
   * @returns {Promise.<projectId: string, permissionLevel: string>}
   */
  workspaceCompetencyPermisssionRevoke = async ({
    accountOrTeamIds,
    documentId,
    collaboratorType,
  }) => {
    const message = {
      type: constants.RTM_WORKSPACE_COMPETENCY_PERMISSION_REVOKE,
      [`${collaboratorType}Ids`]: [accountOrTeamIds],
      documentId,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_WORKSPACE_COMPETENCY_PERMISSION_REVOKE_OK,
      constants.RTM_WORKSPACE_COMPETENCY_PERMISSION_REVOKE_ERROR
    );
    return response;
  };
}

export default KnowledgeMapResolver;
